const getIconUrl = (name, color) => {
  let hex = color.replace('#', '');
  if (hex.length === 3) {
    hex = hex.split('').map(c => c + c).join('');
  }
  return `https://img.icons8.com/ios-filled/50/${hex}/${name}.png`;
};

export const ICONS = {
  phone: (color) => `<img src="${getIconUrl('phone', color)}" width="12" height="12" alt="phone" style="display:block; border:0; outline:none; text-decoration:none;" />`,
  email: (color) => `<img src="${getIconUrl('new-post', color)}" width="12" height="12" alt="email" style="display:block; border:0; outline:none; text-decoration:none;" />`,
  web: (color) => `<img src="${getIconUrl('globe', color)}" width="12" height="12" alt="web" style="display:block; border:0; outline:none; text-decoration:none;" />`,
  linkedin: (color) => `<img src="${getIconUrl('linkedin', color)}" width="12" height="12" alt="linkedin" style="display:block; border:0; outline:none; text-decoration:none;" />`,
  twitter: (color) => `<img src="${getIconUrl('twitter', color)}" width="12" height="12" alt="twitter" style="display:block; border:0; outline:none; text-decoration:none;" />`,
  instagram: (color) => `<img src="${getIconUrl('instagram-new', color)}" width="12" height="12" alt="instagram" style="display:block; border:0; outline:none; text-decoration:none;" />`,
  facebook: (color) => `<img src="${getIconUrl('facebook-new', color)}" width="12" height="12" alt="facebook" style="display:block; border:0; outline:none; text-decoration:none;" />`,
  youtube: (color) => `<img src="${getIconUrl('youtube-play', color)}" width="12" height="12" alt="youtube" style="display:block; border:0; outline:none; text-decoration:none;" />`,
  github: (color) => `<img src="${getIconUrl('github', color)}" width="12" height="12" alt="github" style="display:block; border:0; outline:none; text-decoration:none;" />`,
  location: (color) => `<img src="${getIconUrl('marker', color)}" width="12" height="12" alt="location" style="display:block; border:0; outline:none; text-decoration:none;" />`,
  link: (color) => `<img src="${getIconUrl('link', color)}" width="12" height="12" alt="link" style="display:block; border:0; outline:none; text-decoration:none;" />`,
  calendar: (color) => `<img src="${getIconUrl('calendar', color)}" width="12" height="12" alt="calendar" style="display:block; border:0; outline:none; text-decoration:none;" />`,
};

const renderSocials = (fields, colors, useBrandColors = false) => {
  const socials = [];

  const getIconColor = (brandColor) => useBrandColors ? brandColor : colors.primary;

  const socialMap = [
    { key: 'facebook', icon: 'facebook', color: '#1877F2', baseUrl: 'https://facebook.com/' },
    { key: 'linkedin', icon: 'linkedin', color: '#0A66C2', baseUrl: 'https://linkedin.com/in/' },
    { key: 'twitter', icon: 'twitter', color: '#000000', baseUrl: 'https://twitter.com/' },
    { key: 'instagram', icon: 'instagram', color: '#E4405F', baseUrl: 'https://instagram.com/' },
    { key: 'youtube', icon: 'youtube', color: '#FF0000', baseUrl: 'https://youtube.com/' },
  ];

  for (const social of socialMap) {
    const val = fields[social.key];
    if (typeof val === 'string' && val.trim()) {
      const url = val.startsWith('http') ? val : `${social.baseUrl}${val.replace('@', '')}`;
      socials.push(`<td style="padding-right: 8px;"><a href="${url}" target="_blank" style="text-decoration: none; display: block; line-height: 1;">${ICONS[social.icon](getIconColor(social.color))}</a></td>`);
    }
  }

  if (socials.length === 0) return "";
  return `<table cellpadding="0" cellspacing="0" border="0" style="margin-top: 10px;"><tr>${socials.join("")}</tr></table>`;
};

const renderAdditionalFields = (fields, exclude, colors, order) => {
  // Normalize exclusion list
  const coreFields = ["fullName", "title", "company", "phone", "email", "website", "logoUrl", "avatarUrl", "bannerUrl", "disclaimer", "banner", "linkedin", "twitter", "customFields", "facebook", "instagram", "youtube"].map(f => f.toLowerCase());
  const allExclude = [...new Set([...coreFields, ...exclude.map(e => e.toLowerCase())])];

  const keysToRender = order
    ? order.filter(k => {
        const normalizedKey = k.toLowerCase().trim();
        return !allExclude.includes(normalizedKey) && fields[k];
      })
    : Object.keys(fields).filter(k => {
        const normalizedKey = k.toLowerCase().trim();
        return !allExclude.includes(normalizedKey) && fields[k];
      });

  let html = keysToRender.map(key => `
    <table cellpadding="0" cellspacing="0" border="0" style="font-size: 11px; margin-top: 2px; font-family: Arial, sans-serif;">
      <tr>
        <td>
          <span style="color: ${colors.primary}; font-weight: bold; text-transform: capitalize;">${key.replace(/([A-Z])/g, ' $1').trim()}:</span> <span style="color: ${colors.secondary};">${fields[key]}</span>
        </td>
      </tr>
    </table>
  `).join("");

  if (fields.customFields && Array.isArray(fields.customFields)) {
    const customHtml = fields.customFields.map((cf) => {
      if (cf.type === 'button') {
        const btnStyle = cf.buttonStyle || 'solid';
        const bgColor = btnStyle === 'solid' ? (cf.buttonColor || colors.primary) : 'transparent';
        const textColor = btnStyle === 'solid'
          ? (cf.buttonTextColor || '#ffffff')
          : (cf.buttonColor || colors.primary);
        const border = btnStyle === 'outline' ? `1px solid ${cf.buttonColor || colors.primary}` : 'none';
        const textDecoration = btnStyle === 'link' ? 'underline' : 'none';
        const padding = btnStyle === 'link' ? '0' : '6px 12px';
        const borderRadius = '4px';

        return `
          <table cellpadding="0" cellspacing="0" border="0" style="margin-top: 8px; font-family: Arial, sans-serif;">
            <tr>
              <td>
                <a href="${cf.value}" target="_blank" style="display: inline-block; background-color: ${bgColor}; color: ${textColor}; border: ${border}; text-decoration: ${textDecoration}; padding: ${padding}; border-radius: ${borderRadius}; font-size: 11px; font-weight: bold; text-align: center;">
                  ${cf.icon && cf.icon in ICONS ? ICONS[cf.icon](textColor) : ''}${cf.label}
                </a>
              </td>
            </tr>
          </table>
        `;
      } else if (cf.type === 'image') {
        const wAttr = cf.imageWidth ? `width="${cf.imageWidth}"` : '';
        const hAttr = cf.imageHeight ? `height="${cf.imageHeight}"` : '';

        return `
          <table cellpadding="0" cellspacing="0" border="0" style="margin-top: 8px; font-family: Arial, sans-serif;">
            <tr>
              <td>
                ${(cf.showLabel !== false && cf.label) ? `<div style="font-size: 10px; color: ${colors.secondary}; margin-bottom: 2px;">${cf.label}</div>` : ''}
                <img src="${cf.value}" alt="${cf.label}" ${wAttr} ${hAttr} style="display: block; max-width: 100%; border-radius: 4px;" />
              </td>
            </tr>
          </table>
        `;
      } else {
        const showIcon = cf.showIcon !== false && cf.icon && cf.icon in ICONS;
        const showLabel = cf.showLabel !== false;

        return `
          <table cellpadding="0" cellspacing="0" border="0" style="font-size: 11px; margin-top: 4px; font-family: Arial, sans-serif;">
            <tr>
              ${showIcon ? `<td valign="middle" style="padding-right: 6px;">${ICONS[cf.icon](colors.primary)}</td>` : ''}
              <td valign="middle">
                ${showLabel ? `<span style="color: ${colors.primary}; font-weight: bold;">${cf.label}:</span> ` : ''}<span style="color: ${colors.secondary};">${cf.value}</span>
              </td>
            </tr>
          </table>
        `;
      }
    }).join("");
    html += customHtml;
  }

  return html;
};

const renderBanner = (fields, colors) => {
  if (!fields.banner) return "";
  return `
    <table cellpadding="0" cellspacing="0" border="0" style="margin-top: 20px; width: 100%; border-top: 1px solid #eeeeee; font-family: Arial, sans-serif;">
      <tr>
        <td style="padding-top: 15px; font-size: 11px; color: ${colors.secondary};">
          ${fields.banner}
        </td>
      </tr>
    </table>
  `;
};

export const SIGNATURE_TEMPLATES = [
  {
    id: "modern",
    name: "Modern Sidebar",
    render: (fields, colors, order) => `
      <table cellpadding="0" cellspacing="0" border="0" style="font-family: Arial, sans-serif; color: ${colors.secondary}; line-height: 1.5;">
        <tr>
          <td valign="top" style="padding-right: 20px;">
            <img src="${fields.logoUrl}" width="70" height="70" style="border-radius: 8px; display: block; outline: none; border: 0;">
          </td>
          <td width="3" style="width: 3px; background-color: ${colors.primary}; font-size: 1px; line-height: 1px;">&nbsp;</td>
          <td valign="top" style="padding-left: 20px;">
            <table cellpadding="0" cellspacing="0" border="0">
              <tr>
                <td>
                  <div style="font-size: 18px; font-weight: bold; color: ${colors.primary};">${fields.fullName}</div>
                  <div style="font-size: 14px; margin-bottom: 8px; color: ${colors.secondary};">${fields.title} | ${fields.company}</div>
                  <table cellpadding="0" cellspacing="0" border="0" style="font-size: 12px; color: ${colors.secondary};">
                    ${fields.phone ? `<tr><td valign="middle" style="padding-bottom: 4px; padding-right: 8px;">${ICONS.phone(colors.primary)}</td><td valign="middle" style="padding-bottom: 4px; color: ${colors.secondary};">${fields.phone}</td></tr>` : ''}
                    ${fields.email ? `<tr><td valign="middle" style="padding-bottom: 4px; padding-right: 8px;">${ICONS.email(colors.primary)}</td><td valign="middle" style="padding-bottom: 4px;"><a href="mailto:${fields.email}" style="color: ${colors.secondary}; text-decoration: none;">${fields.email}</a></td></tr>` : ''}
                    ${fields.website ? `<tr><td valign="middle" style="padding-bottom: 4px; padding-right: 8px;">${ICONS.web(colors.primary)}</td><td valign="middle"><a href="https://${fields.website}" style="color: ${colors.secondary}; text-decoration: none;">${fields.website}</a></td></tr>` : ''}
                  </table>
                  ${renderSocials(fields, colors)}
                  ${renderAdditionalFields(fields, [], colors, order)}
                </td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
      ${renderBanner(fields, colors)}
    `
  },
  {
    id: "minimal",
    name: "Minimalist",
    render: (fields, colors, order) => `
      <table cellpadding="0" cellspacing="0" border="0" style="font-family: Helvetica, Arial, sans-serif; color: ${colors.secondary}; max-width: 500px;">
        <tr>
          <td>
            <div style="font-size: 16px; font-weight: bold; color: ${colors.primary}; text-transform: uppercase; letter-spacing: 1px;">${fields.fullName}</div>
            <table cellpadding="0" cellspacing="0" border="0" style="width: 100%; border-bottom: 1px solid #eeeeee; margin-bottom: 10px;">
              <tr>
                <td style="font-size: 13px; padding-bottom: 5px; color: ${colors.secondary};">
                  ${fields.title} at ${fields.company}
                </td>
              </tr>
            </table>
            <table cellpadding="0" cellspacing="0" border="0" style="font-size: 11px; color: ${colors.secondary};">
              <tr>
                ${fields.email ? `<td valign="middle" style="padding-right: 6px;">${ICONS.email(colors.primary)}</td><td valign="middle" style="padding-right: 12px; color: ${colors.secondary};">${fields.email}</td>` : ''}
                ${fields.phone ? `<td valign="middle" style="padding-right: 6px;">${ICONS.phone(colors.primary)}</td><td valign="middle" style="padding-right: 12px; color: ${colors.secondary};">${fields.phone}</td>` : ''}
                ${fields.website ? `<td valign="middle" style="padding-right: 6px;">${ICONS.web(colors.primary)}</td><td valign="middle"><a href="https://${fields.website}" style="color: ${colors.primary}; text-decoration: none;">${fields.website}</a></td>` : ''}
              </tr>
            </table>
            ${renderSocials(fields, colors)}
            <table cellpadding="0" cellspacing="0" border="0" style="margin-top: 5px;">
              <tr>
                <td>${renderAdditionalFields(fields, [], colors, order)}</td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
      ${renderBanner(fields, colors)}
    `
  },
  {
    id: "branded",
    name: "Branded Bold",
    render: (fields, colors, order) => `
      <table cellpadding="0" cellspacing="0" border="0" style="font-family: 'Segoe UI', Tahoma, sans-serif; max-width: 500px;">
        <tr>
          <td style="background-color: ${colors.primary}; padding: 20px; border-radius: 12px 0 0 12px;" valign="middle">
            <img src="${fields.logoUrl}" width="60" style="display: block; border: 0;">
          </td>
          <td style="padding: 20px; border: 1px solid #eeeeee; border-left: none; border-radius: 0 12px 12px 0;">
            <div style="font-size: 20px; font-weight: 900; color: ${colors.primary};">${fields.fullName}</div>
            <div style="font-size: 12px; color: ${colors.accent}; font-weight: bold; margin-bottom: 10px;">${fields.title.toUpperCase()}</div>
            <table cellpadding="0" cellspacing="0" border="0" style="font-size: 12px; color: #666666;">
              ${fields.phone ? `<tr><td valign="middle" style="padding-bottom: 4px; padding-right: 6px;">${ICONS.phone(colors.primary)}</td><td valign="middle" style="padding-bottom: 4px; color: #666666;">${fields.phone}</td></tr>` : ''}
              ${fields.email ? `<tr><td valign="middle" style="padding-bottom: 4px; padding-right: 6px;">${ICONS.email(colors.primary)}</td><td valign="middle" style="padding-bottom: 4px; color: #666666;">${fields.email}</td></tr>` : ''}
              ${fields.website ? `<tr><td valign="middle" style="padding-bottom: 4px; padding-right: 6px;">${ICONS.web(colors.primary)}</td><td valign="middle" style="padding-bottom: 4px;"><a href="https://${fields.website}" style="color: ${colors.primary}; font-weight: bold; text-decoration: none;">${fields.website}</a></td></tr>` : ''}
              <tr><td colspan="2" style="padding-top: 5px;">${renderSocials(fields, colors)}</td></tr>
              <tr><td colspan="2" style="padding-top: 5px;">${renderAdditionalFields(fields, [], colors, order)}</td></tr>
            </table>
          </td>
        </tr>
      </table>
      ${renderBanner(fields, colors)}
    `
  },
  {
    id: "elegant",
    name: "Elegant Serif",
    render: (fields, colors, order) => `
      <table cellpadding="0" cellspacing="0" border="0" style="font-family: 'Times New Roman', Times, serif; color: ${colors.secondary}; max-width: 400px; border-top: 2px solid ${colors.accent}; border-bottom: 2px solid ${colors.accent};">
        <tr>
          <td style="padding: 15px 0;">
            <div style="font-size: 22px; font-style: italic; color: ${colors.primary}; margin-bottom: 5px;">${fields.fullName}</div>
            <div style="font-size: 14px; text-transform: uppercase; letter-spacing: 2px; color: #999999; margin-bottom: 10px;">${fields.title}</div>
            <table cellpadding="0" cellspacing="0" border="0" style="font-size: 12px; line-height: 1.8; color: ${colors.secondary};">
              ${fields.phone ? `<tr><td valign="middle" style="padding-right: 8px;">${ICONS.phone(colors.primary)}</td><td valign="middle" style="color: ${colors.secondary};">${fields.phone}</td></tr>` : ''}
              ${fields.email ? `<tr><td valign="middle" style="padding-right: 8px;">${ICONS.email(colors.primary)}</td><td valign="middle" style="color: ${colors.secondary};">${fields.email}</td></tr>` : ''}
              ${fields.website ? `<tr><td valign="middle" style="padding-right: 8px;">${ICONS.web(colors.primary)}</td><td valign="middle" style="color: ${colors.secondary};">${fields.website}</td></tr>` : ''}
            </table>
            ${renderSocials(fields, colors)}
            ${renderAdditionalFields(fields, [], colors, order)}
          </td>
        </tr>
      </table>
      ${renderBanner(fields, colors)}
    `
  },
  {
    id: "compact",
    name: "Compact Round",
    render: (fields, colors, order) => `
      <table cellpadding="0" cellspacing="0" border="0" style="font-family: Arial, sans-serif; max-width: 500px;">
        <tr>
          <td valign="top">
            <img src="${fields.logoUrl}" width="50" height="50" style="border-radius: 50%; border: 2px solid ${colors.primary}; display: block;">
          </td>
          <td style="padding-left: 15px;" valign="top">
            <div style="font-size: 15px; font-weight: bold; color: ${colors.primary};">${fields.fullName}</div>
            <table cellpadding="0" cellspacing="0" border="0">
              ${fields.phone ? `<tr><td valign="middle" style="padding-right: 6px; padding-bottom: 2px;">${ICONS.phone(colors.primary)}</td><td valign="middle" style="font-size: 12px; color: #777777; padding-bottom: 2px;">${fields.phone}</td></tr>` : ''}
              ${fields.email ? `<tr><td valign="middle" style="padding-right: 6px; padding-bottom: 2px;">${ICONS.email(colors.accent)}</td><td valign="middle" style="font-size: 11px; padding-bottom: 2px;"><a href="mailto:${fields.email}" style="color: ${colors.accent}; text-decoration: none;">${fields.email}</a></td></tr>` : ''}
            </table>
            ${renderSocials(fields, colors)}
            ${renderAdditionalFields(fields, [], colors, order)}
          </td>
        </tr>
      </table>
      ${renderBanner(fields, colors)}
    `
  },
  {
    id: "professional",
    name: "Corporate Pro",
    render: (fields, colors, order) => `
      <table cellpadding="0" cellspacing="0" border="0" style="font-family: Arial, sans-serif; color: #333333; max-width: 500px;">
        <tr>
          <td valign="middle">
             <div style="font-size: 18px; font-weight: bold;">${fields.fullName}</div>
             <div style="font-size: 13px; color: ${colors.primary}; font-weight: bold;">${fields.title}</div>
          </td>
        </tr>
        <tr>
          <td style="padding: 10px 0; border-top: 1px solid #dddddd; margin-top: 10px;">
            <table cellpadding="0" cellspacing="0" border="0" style="font-size: 12px; color: #333333;">
              <tr>
                ${fields.phone ? `<td valign="middle" style="padding-right: 5px;">${ICONS.phone(colors.primary)}</td><td valign="middle" style="padding-right: 15px; color: #333333;">${fields.phone}</td>` : ''}
                ${fields.email ? `<td valign="middle" style="padding-right: 5px;">${ICONS.email(colors.primary)}</td><td valign="middle" style="padding-right: 15px; color: #333333;">${fields.email}</td>` : ''}
                ${fields.website ? `<td valign="middle" style="padding-right: 5px;">${ICONS.web(colors.primary)}</td><td valign="middle" style="color: #333333;">${fields.website}</td>` : ''}
              </tr>
            </table>
            ${renderSocials(fields, colors)}
            <table cellpadding="0" cellspacing="0" border="0" style="margin-top: 5px;">
              <tr>
                <td>${renderAdditionalFields(fields, [], colors, order)}</td>
              </tr>
            </table>
          </td>
        </tr>
        <tr>
          <td>
            <img src="${fields.logoUrl}" height="30" style="margin-top: 5px; display: block; border: 0;">
          </td>
        </tr>
      </table>
      ${renderBanner(fields, colors)}
    `
  },
  {
    id: "creative",
    name: "Creative Accent",
    render: (fields, colors, order) => `
      <table cellpadding="0" cellspacing="0" border="0" style="font-family: 'Trebuchet MS', sans-serif; max-width: 500px;">
        <tr>
          <td width="5" style="width: 5px; background-color: ${colors.primary}; font-size: 1px; line-height: 1px;">&nbsp;</td>
          <td style="padding-left: 15px;">
            <div style="font-size: 20px; font-weight: bold; color: #000000;">${fields.fullName}</div>
            <div style="font-size: 14px; color: ${colors.secondary}; margin-bottom: 10px;">${fields.title}</div>
            <table cellpadding="0" cellspacing="0" border="0" style="margin-bottom: 10px;">
              <tr>
                <td style="background-color: ${colors.primary}; color: #ffffff; padding: 2px 8px; border-radius: 4px; font-size: 12px; font-weight: bold;">
                  ${fields.company}
                </td>
              </tr>
            </table>
            <table cellpadding="0" cellspacing="0" border="0" style="font-size: 12px; color: ${colors.secondary};">
              <tr>
                ${fields.phone ? `<td valign="middle" style="padding-right: 5px;">${ICONS.phone(colors.primary)}</td><td valign="middle" style="padding-right: 10px;">${fields.phone}</td>` : ''}
                ${fields.phone && fields.email ? `<td valign="middle" style="padding-right: 10px; color: #cccccc;">|</td>` : ''}
                ${fields.email ? `<td valign="middle" style="padding-right: 5px;">${ICONS.email(colors.primary)}</td><td valign="middle">${fields.email}</td>` : ''}
              </tr>
            </table>
            ${renderSocials(fields, colors)}
            ${renderAdditionalFields(fields, [], colors, order)}
          </td>
        </tr>
      </table>
      ${renderBanner(fields, colors)}
    `
  },
  {
    id: "clean",
    name: "Clean Stack",
    render: (fields, colors, order) => `
      <table cellpadding="0" cellspacing="0" border="0" style="font-family: Arial, sans-serif; max-width: 500px;">
        <tr>
          <td><img src="${fields.logoUrl}" width="100" style="margin-bottom: 10px; display: block; border: 0;"></td>
        </tr>
        <tr>
          <td>
            <div style="font-size: 16px; font-weight: bold; color: #111111;">${fields.fullName}</div>
            <div style="font-size: 13px; color: #666666; margin-bottom: 5px;">${fields.title}</div>
            <table cellpadding="0" cellspacing="0" border="0" style="margin-bottom: 10px;">
              <tr>
                <td height="2" width="30" style="height: 2px; width: 30px; background-color: ${colors.accent}; font-size: 1px; line-height: 1px;">&nbsp;</td>
              </tr>
            </table>
            <table cellpadding="0" cellspacing="0" border="0" style="font-size: 12px; color: #444444;">
              <tr>
                ${fields.phone ? `<td valign="middle" style="padding-right: 5px;">${ICONS.phone(colors.primary)}</td><td valign="middle" style="padding-right: 8px;">${fields.phone}</td>` : ''}
                ${fields.phone && fields.email ? `<td valign="middle" style="padding-right: 8px; color: #dddddd;">&bull;</td>` : ''}
                ${fields.email ? `<td valign="middle" style="padding-right: 5px;">${ICONS.email(colors.primary)}</td><td valign="middle">${fields.email}</td>` : ''}
              </tr>
            </table>
            ${fields.website ? `
            <table cellpadding="0" cellspacing="0" border="0" style="font-size: 12px; color: #444444; margin-top: 5px;">
              <tr><td valign="middle" style="padding-right: 5px;">${ICONS.web(colors.primary)}</td><td valign="middle"><a href="https://${fields.website}" style="color: ${colors.primary}; text-decoration: none; font-weight: bold;">${fields.website}</a></td></tr>
            </table>
            ` : ''}
            <table cellpadding="0" cellspacing="0" border="0" style="font-size: 12px; color: #444444; margin-top: 5px;">
              <tr>
                <td>
                  ${renderSocials(fields, colors)}
                  ${renderAdditionalFields(fields, [], colors, order)}
                </td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
      ${renderBanner(fields, colors)}
    `
  },
  {
    id: "tech",
    name: "Tech Mono",
    render: (fields, colors, order) => `
      <table cellpadding="0" cellspacing="0" border="0" style="font-family: 'Courier New', Courier, monospace; background-color: #f9f9f9; border: 1px solid #eeeeee; border-radius: 8px; max-width: 500px; width: 100%;">
        <tr>
          <td style="padding: 15px;">
            <div style="color: ${colors.primary}; font-weight: bold;">> ${fields.fullName}</div>
            <div style="color: #666666; font-size: 12px; margin-bottom: 10px;">// ${fields.title}</div>
            <table cellpadding="0" cellspacing="0" border="0" style="font-size: 11px; color: #444444; font-family: 'Courier New', Courier, monospace;">
              ${fields.email ? `<tr><td valign="middle" style="padding-right: 5px; padding-bottom: 3px;">[conn]</td><td valign="middle" style="padding-right: 5px; padding-bottom: 3px;">${ICONS.email(colors.primary)}</td><td valign="middle" style="padding-bottom: 3px; color: #444444;">${fields.email}</td></tr>` : ''}
              ${fields.phone ? `<tr><td valign="middle" style="padding-right: 5px; padding-bottom: 3px;">[conn]</td><td valign="middle" style="padding-right: 5px; padding-bottom: 3px;">${ICONS.phone(colors.primary)}</td><td valign="middle" style="padding-bottom: 3px; color: #444444;">${fields.phone}</td></tr>` : ''}
              ${fields.website ? `<tr><td valign="middle" style="padding-right: 5px; padding-bottom: 3px;">[site]</td><td valign="middle" style="padding-right: 5px; padding-bottom: 3px;">${ICONS.web(colors.primary)}</td><td valign="middle" style="padding-bottom: 3px; color: #444444;">${fields.website}</td></tr>` : ''}
            </table>
            <table cellpadding="0" cellspacing="0" border="0" style="font-size: 11px; color: #444444; margin-top: 5px;">
              <tr>
                <td>
                  ${renderSocials(fields, colors)}
                  ${renderAdditionalFields(fields, [], colors, order)}
                </td>
              </tr>
            </table>
            <img src="${fields.logoUrl}" height="20" style="opacity: 0.7; margin-top: 10px; display: block; border: 0;">
          </td>
        </tr>
      </table>
      ${renderBanner(fields, colors)}
    `
  },
  {
    id: "social",
    name: "Social Focus",
    render: (fields, colors, order) => `
      <table cellpadding="0" cellspacing="0" border="0" style="font-family: Arial, sans-serif; max-width: 500px; width: 100%;">
        <tr>
          <td>
            <table cellpadding="0" cellspacing="0" border="0" style="width: 100%;">
              <tr>
                <td style="font-size: 19px; font-weight: 800; color: ${colors.primary};">${fields.fullName}</td>
                <td align="right">
                  <img src="${fields.logoUrl}" width="40" height="40" style="border-radius: 4px; display: block; border: 0;">
                </td>
              </tr>
            </table>
            <table cellpadding="0" cellspacing="0" border="0" style="width: 100%; border-top: 1px solid ${colors.accent}; margin-top: 5px;">
              <tr>
                <td style="font-size: 13px; color: ${colors.secondary}; padding-top: 5px;">
                  ${fields.title} @ ${fields.company}
                </td>
              </tr>
            </table>
            <table cellpadding="0" cellspacing="0" border="0" style="width: 100%; margin-top: 10px;">
              <tr>
                <td>
                   ${renderSocials(fields, colors)}
                   ${renderAdditionalFields(fields, ["linkedin", "twitter"], colors, order)}
                </td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
      ${renderBanner(fields, colors)}
    `
  },
  {
    id: "editorial",
    name: "Editorial Elite",
    render: (fields, colors, order) => `
      <table cellpadding="0" cellspacing="0" border="0" style="font-family: 'Georgia', serif; max-width: 500px;">
        <tr>
          <td>
            <table cellpadding="0" cellspacing="0" border="0">
              <tr>
                <td valign="top" style="padding-bottom: 5px;">
                  <div style="font-size: 28px; color: #000000; line-height: 1.1; font-weight: normal;">${fields.fullName}</div>
                  <div style="font-family: Arial, sans-serif; font-size: 11px; text-transform: uppercase; letter-spacing: 2px; color: ${colors.primary}; font-weight: bold; margin-top: 4px;">${fields.title}</div>
                </td>
              </tr>
              <tr>
                <td style="padding-top: 15px; border-top: 1px solid #000000;">
                  <table cellpadding="0" cellspacing="0" border="0" style="font-family: Arial, sans-serif; font-size: 11px; color: #666666; line-height: 1.6;">
                    <tr>
                      <td style="padding-right: 20px;">
                        <span style="color: #000000; font-weight: bold;">T</span> ${fields.phone}<br>
                        <span style="color: #000000; font-weight: bold;">E</span> ${fields.email}
                      </td>
                      <td style="padding-right: 20px; border-left: 1px solid #eeeeee; padding-left: 20px;">
                        <span style="color: #000000; font-weight: bold;">W</span> ${fields.website}<br>
                        <span style="color: #000000; font-weight: bold;">C</span> ${fields.company}
                      </td>
                      <td valign="bottom" align="right" style="padding-left: 20px;">
                        <img src="${fields.logoUrl}" height="24" style="display: block; border: 0;">
                      </td>
                    </tr>
                  </table>
                  ${renderSocials(fields, colors)}
                  ${renderAdditionalFields(fields, [], colors, order)}
                </td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
      ${renderBanner(fields, colors)}
    `
  },
  {
    id: "executive",
    name: "Executive Accent",
    render: (fields, colors, order) => `
      <table cellpadding="0" cellspacing="0" border="0" style="font-family: 'Segoe UI', Arial, sans-serif; max-width: 550px;">
        <tr>
          <td width="6" style="background-color: ${colors.primary}; border-radius: 3px; font-size: 1px; line-height: 1px;">&nbsp;</td>
          <td style="padding-left: 20px;">
            <table cellpadding="0" cellspacing="0" border="0">
              <tr>
                <td valign="top" style="padding-bottom: 10px;">
                  <div style="font-size: 20px; font-weight: 800; color: #1a1a1a; line-height: 1;">${fields.fullName}</div>
                  <div style="font-size: 13px; color: ${colors.secondary}; margin-top: 4px;">${fields.title} <span style="color: ${colors.primary}; font-weight: bold;">/</span> ${fields.company}</div>
                </td>
              </tr>
              <tr>
                <td>
                  <table cellpadding="0" cellspacing="0" border="0" style="font-size: 12px; color: #444444;">
                    <tr>
                      ${fields.phone ? `<td valign="middle" style="padding-right: 5px;">${ICONS.phone(colors.primary)}</td><td valign="middle" style="padding-right: 15px; color: #444444;">${fields.phone}</td>` : ''}
                      ${fields.email ? `<td valign="middle" style="padding-right: 5px;">${ICONS.email(colors.primary)}</td><td valign="middle" style="padding-right: 15px; color: #444444;">${fields.email}</td>` : ''}
                      ${fields.website ? `<td valign="middle" style="padding-right: 5px;">${ICONS.web(colors.primary)}</td><td valign="middle" style="color: #444444;">${fields.website}</td>` : ''}
                    </tr>
                  </table>
                </td>
              </tr>
              <tr>
                <td style="padding-top: 10px;">
                  ${renderSocials(fields, colors)}
                  ${renderAdditionalFields(fields, [], colors, order)}
                </td>
              </tr>
            </table>
          </td>
          <td valign="top" align="right" style="padding-left: 30px;">
            <img src="${fields.logoUrl}" width="80" style="border-radius: 6px; display: block; border: 0;">
          </td>
        </tr>
      </table>
      ${renderBanner(fields, colors)}
    `
  },
  {
    id: "glass",
    name: "Minimalist Glass",
    render: (fields, colors, order) => `
      <table cellpadding="0" cellspacing="0" border="0" style="max-width: 480px; font-family: Arial, sans-serif; background-color: #f8f9fa; border-radius: 20px; border: 1px solid #eeeeee;">
        <tr>
          <td style="padding: 24px;">
            <table cellpadding="0" cellspacing="0" border="0">
              <tr>
                <td valign="top" style="padding-right: 20px;">
                  <img src="${fields.logoUrl}" width="64" height="64" style="border-radius: 14px; display: block; border: 0;">
                </td>
                <td valign="top">
                  <div style="font-size: 22px; font-weight: 800; color: #111111; letter-spacing: -0.5px; line-height: 1.1;">${fields.fullName}</div>
                  <div style="font-size: 14px; color: ${colors.primary}; font-weight: 600; margin-top: 4px;">${fields.title}</div>
                  <div style="font-size: 12px; color: #888888; text-transform: uppercase; letter-spacing: 1px; margin-top: 2px;">${fields.company}</div>
                </td>
              </tr>
            </table>
            <table cellpadding="0" cellspacing="0" border="0" style="width: 100%; height: 1px; margin: 20px 0;">
              <tr><td style="background-color: #e5e5e5; font-size: 1px; line-height: 1px;">&nbsp;</td></tr>
            </table>
            <table cellpadding="0" cellspacing="0" border="0" style="font-size: 13px; color: #444444; line-height: 1.6;">
              <tr>
                <td style="padding-right: 24px;">
                  <span style="color: ${colors.primary}; font-weight: bold; margin-right: 5px;">E</span> <span style="color: #444444;">${fields.email}</span>
                </td>
                <td>
                  <span style="color: ${colors.primary}; font-weight: bold; margin-right: 5px;">P</span> <span style="color: #444444;">${fields.phone}</span>
                </td>
              </tr>
              <tr>
                <td colspan="2" style="padding-top: 4px;">
                  <span style="color: ${colors.primary}; font-weight: bold; margin-right: 5px;">W</span> <span style="color: #444444;">${fields.website}</span>
                </td>
              </tr>
            </table>
            <table cellpadding="0" cellspacing="0" border="0" style="margin-top: 16px;">
              <tr>
                <td>
                  ${renderSocials(fields, colors)}
                  ${renderAdditionalFields(fields, [], colors, order)}
                </td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
      ${renderBanner(fields, colors)}
    `
  },
  {
    id: "catalyst",
    name: "The Catalyst",
    render: (fields, colors, order) => `
      <table cellpadding="0" cellspacing="0" border="0" style="max-width: 500px; font-family: Arial, sans-serif; background-color: #ffffff; border: 1px solid #eeeeee; border-radius: 4px;">
        <tr>
          <td style="background-color: ${colors.primary}; width: 120px; text-align: center; vertical-align: middle; padding: 20px;">
            <img src="${fields.logoUrl}" width="80" style="display: block; margin: 0 auto; border: 0; border-radius: 4px;">
          </td>
          <td style="padding: 30px; vertical-align: top;">
            <div style="font-size: 24px; font-weight: 800; color: #111111; line-height: 1; margin-bottom: 5px;">${fields.fullName}</div>
            <div style="font-size: 13px; color: ${colors.primary}; font-weight: bold; text-transform: uppercase; letter-spacing: 1.5px; margin-bottom: 15px;">${fields.title}</div>

            <table cellpadding="0" cellspacing="0" border="0" style="font-size: 13px; color: #666666; line-height: 1.8;">
              <tr>
                <td><span style="color: #111111; font-weight: bold;">M</span> ${fields.phone}</td>
              </tr>
              <tr>
                <td><span style="color: #111111; font-weight: bold;">E</span> ${fields.email}</td>
              </tr>
              <tr>
                <td><span style="color: #111111; font-weight: bold;">W</span> ${fields.website}</td>
              </tr>
            </table>

            <table cellpadding="0" cellspacing="0" border="0" style="width: 100%; height: 1px; margin-top: 15px; border-top: 1px solid #f0f0f0;">
              <tr><td style="font-size: 1px; line-height: 1px;">&nbsp;</td></tr>
            </table>

            <table cellpadding="0" cellspacing="0" border="0" style="margin-top: 15px;">
              <tr>
                <td>
                  ${renderSocials(fields, colors)}
                  ${renderAdditionalFields(fields, [], colors, order)}
                </td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
      ${renderBanner(fields, colors)}
    `
  },
  {
    id: "professional-modern",
    name: "Professional Modern",
    render: (fields, colors, order) => `
      <table cellpadding="0" cellspacing="0" border="0" style="max-width: 650px; font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; background-color: #ffffff; border: 1px solid #f0f0f0; border-radius: 20px;">
        <tr>
          <td style="padding: 35px;">
            <table cellpadding="0" cellspacing="0" border="0" style="width: 100%;">
              <tr>
                <td valign="middle" align="center" style="width: 130px; padding-right: 20px;">
                   <table cellpadding="0" cellspacing="0" border="0">
                    <tr>
                      <td align="center" valign="middle" style="height: 120px; width: 120px;">
                        <img src="${fields.logoUrl}" alt="${fields.company || 'Logo'}" width="120" style="max-width: 120px; max-height: 120px; display: block; border: 0;" />
                      </td>
                    </tr>
                    ${fields.company ? `
                    <tr>
                      <td align="center" style="padding-top: 10px;">
                        <div style="font-size: 20px; font-weight: 900; color: #111111; font-family: 'Arial Black', Gadget, sans-serif;">${fields.company}</div>
                      </td>
                    </tr>
                    ` : ''}
                   </table>
                </td>
                <td width="1" style="width: 1px; background-color: #eeeeee; font-size: 1px; line-height: 1px;">&nbsp;</td>
                <td valign="middle" style="padding: 0 25px;">
                  <table cellpadding="0" cellspacing="0" border="0">
                    <tr>
                      <td>
                        <div style="font-size: 28px; font-weight: 800; color: ${colors.primary}; margin-bottom: 4px; letter-spacing: -0.5px;">${fields.fullName}</div>
                        <div style="font-size: 15px; font-weight: 600; color: ${colors.secondary}; opacity: 0.8; margin-bottom: 20px;">${fields.title}</div>

                        <table cellpadding="0" cellspacing="0" border="0" style="font-size: 12px; color: #444444; line-height: 1.6;">
                          <tr>
                             <td style="padding-bottom: 4px;">
                               <span style="font-weight: 700; color: #111111;">mobile:</span> ${fields.phone}
                               <span style="color: #cccccc; margin: 0 8px;">|</span>
                               <span style="font-weight: 700; color: #111111;">telephone:</span> ${fields.phone}
                             </td>
                          </tr>
                          <tr>
                            <td style="padding-bottom: 4px;">
                              <span style="font-weight: 700; color: #111111;">email:</span> <a href="mailto:${fields.email}" style="color: #444444; text-decoration: none;">${fields.email}</a>
                            </td>
                          </tr>
                          ${fields.address ? `
                          <tr>
                            <td>
                              <span style="color: #666666;">${fields.address}</span>
                            </td>
                          </tr>
                          ` : ''}
                        </table>
                        <div style="margin-top: 10px;">
                          ${renderAdditionalFields(fields, [], colors, order)}
                        </div>
                      </td>
                    </tr>
                  </table>
                </td>
                ${fields.avatarUrl ? `
                <td width="1" style="width: 1px; background-color: #eeeeee; font-size: 1px; line-height: 1px;">&nbsp;</td>
                <td valign="middle" align="center" style="width: 130px; padding-left: 20px;">
                  <img src="${fields.avatarUrl}" alt="${fields.fullName}" width="120" height="120" style="width: 120px; height: 120px; border-radius: 4px; display: block; background-color: #f9f9f9; border: 0;" />
                </td>
                ` : ''}
              </tr>
            </table>

            <!-- Social and Ratings -->
            <table cellpadding="0" cellspacing="0" border="0" style="width: 100%; margin-top: 25px;">
              <tr>
                <td valign="middle">
                  ${renderSocials(fields, colors, true)}
                </td>
                <td valign="middle" align="right" style="font-size: 11px; color: #888888; font-weight: 500;">
                  Please rate the quality of the support you received:
                  <span style="font-size: 18px; margin-left: 10px; vertical-align: middle;">😡 🙁 🙂 😍</span>
                </td>
              </tr>
            </table>

            ${fields.bannerUrl ? `
              <table cellpadding="0" cellspacing="0" border="0" style="width: 100%; margin-top: 15px;">
                <tr>
                  <td>
                    <img src="${fields.bannerUrl}" alt="Banner" style="display: block; max-width: 100%; height: auto; border-radius: 4px;" />
                  </td>
                </tr>
              </table>
            ` : ''}

            ${(fields.disclaimer || fields.banner) ? `
              <table cellpadding="0" cellspacing="0" border="0" style="width: 100%; margin-top: 15px; border-top: 1px solid #eeeeee;">
                <tr>
                  <td style="padding-top: 12px; font-size: 10px; color: #888888; line-height: 1.4;">
                    ${fields.disclaimer || fields.banner}
                  </td>
                </tr>
              </table>
            ` : ''}

            ${fields.bottomLinks ? `
            <table cellpadding="0" cellspacing="0" border="0" style="width: 100%; margin-top: 20px; border-top: 1.5px solid #f0f0f0;">
              <tr>
                <td align="center" style="padding-top: 15px; font-size: 12px; color: ${colors.primary}; font-weight: 700;">
                  ${fields.bottomLinks.split('|').map((link, i, arr) => `
                    <a href="#" style="color: ${colors.primary}; text-decoration: none; margin: 0 10px;">${link.trim()}</a>
                    ${i < arr.length - 1 ? '<span style="color: #dddddd;">|</span>' : ''}
                  `).join('')}
                </td>
              </tr>
            </table>
            ` : ''}
          </td>
        </tr>
      </table>
    `
  }
];
